import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Constant from "../../../../../constant"
import warningIcon from "../../../../assets/images/WarningIcon.svg"
import Dateinfo from "../../../../components/Dateinfo"
import { getMyProfile } from "../../../../redux/action/accountAction"
import { logoutUserKeycloak } from "../../../../redux/action/authAction"
import AccountService from "../../../../services/AccountService"
import InvitationService from "../../../../services/InvitationService"
import NegotiationService from "../../../../services/NegotiationService"
import Chat from "../../../Chat"
import NegotiationOfferAsListModule from "../../../negotiation-offer/negotiation-offer-as-list"
import SpectatorModule from "../../../spectator/spectator.module"
import ChatReadOnly from "../ChatReadOnly"
import NegotiationInformation from "../NegotiationInformation"
import OfferNegotiation from "../offer-negotiation.module"

const VendorNegotiationOnline = () => {
   const { negotiationId, negotiationBatchId } = useParams()
   const dispatch = useDispatch()
   const negotiationService = new NegotiationService()
   const accountService = new AccountService()
   const invitationService = new InvitationService()

   const [permitMessage, setPermitMessage] = useState(true)
   const [accountId, setAccountId] = useState(null)
   const [accountName, setAccountName] = useState(null)
   const [toAccountId, setToAccountId] = useState(null)
   const [negotiation, setNegotiation] = useState({})
   const [account, setAccount] = useState({})

   useEffect(() => {
      checkLogin()
   }, [negotiation?.status]) /** chatbox is updated immediately once nego started/ended */

   const checkInvitation = (foreignKey, _accountId) => {
      dispatch(
         invitationService.findByForeignKeyAndToAccountIdAndType(foreignKey, _accountId, "NEGOTIATION", (res) => {
            console.log(res)
         }),
      )
   }

   const checkLogin = () => {
      const email = new URLSearchParams(location.search).get("email")
      if (email) {
         localStorage.setItem("email", email)
      }

      const currentUrl = location.href
      const access_token = localStorage.getItem("access_token")
      if (!access_token) {
         location.href = "/vendor-login?prev=" + currentUrl
      } else {
         dispatch(
            getMyProfile((res) => {
               const account = res.account
               // Emailed link targets a specific recipient; a stale session for a different account must
               // not silently govern the negotiation — log it out and re-login as the invited vendor.
               if (email && account.email && account.email.toLowerCase() !== email.toLowerCase()) {
                  dispatch(logoutUserKeycloak(account.email))
                  localStorage.removeItem("access_token")
                  localStorage.removeItem("refresh_token")
                  location.href = "/vendor-login?prev=" + currentUrl
                  return
               }
               setAccount(account)
               setAccountId(account._id)
               setAccountName(account.email)
               if (account.role === Constant.ROLE.SELLER_AUCTION) {
                  getNegotiationDetail()
               } else if (account.role === Constant.ROLE.SPECTATOR_AUCTION) {
                  checkInvitation(negotiationId, account._id)
               }
            }),
         )
      }
   }

   const getNegotiationDetail = () => {
      dispatch(
         negotiationService.findById(negotiationId, (res) => {
            setNegotiation(res)
            setToAccountId(res.fromAccountId)
            dispatch(
               accountService.findById(res.toAccountId, (resAccountTo) => {
                  setAccountName(resAccountTo.email)
                  setAccountId(resAccountTo._id)
               }),
            )
         }),
      )
   }

   return (
      <div className="ml-5 mr-4" style={{ marginTop: "10px" }}>
         {negotiation.status === Constant.STATUS.CANCELED && (
            <Row className="mb-3">
               <Col>
                  <div
                     className="d-flex align-items-center px-3"
                     style={{
                        backgroundColor: "#fde9ef",
                        color: "#454545",
                        fontSize: "12px",
                        fontWeight: "400",
                        borderRadius: "5px",
                        height: "40px",
                     }}
                  >
                     <img src={warningIcon} className="mr-2" />
                     <p>
                        This negotiation has been canceled at{" "}
                        <strong>
                           {" "}
                           <Dateinfo
                              date={negotiation.updatedAt}
                              format="dd mmmm yyyy HH:MM"
                              style={{ all: "unset" }}
                           />
                        </strong>{" "}
                        by <strong> {negotiation.canceledBy}</strong>. The reason is &ldquo;
                        <strong
                           style={{ display: "inline-block", lineHeight: "0px" }}
                           dangerouslySetInnerHTML={{
                              __html: negotiation.cancelReason,
                           }}
                        />
                        &rdquo;.
                     </p>
                  </div>
               </Col>
            </Row>
         )}
         <Row className="mx-0 px-0">
            <Col className="px-0" md="8">
               <NegotiationInformation
                  account={account}
                  negotiationBatchId={negotiationBatchId}
                  negotiationId={negotiationId}
               ></NegotiationInformation>
            </Col>
            <Col md="4">
               {accountId !== null && (
                  <SpectatorModule roomId={negotiationId} userId={accountId} permitAdd={false}></SpectatorModule>
               )}
            </Col>
         </Row>
         <Row className="mt-4">
            <Col md="5" className="px-0">
               {accountName !== null &&
               accountId !== null &&
               (negotiation?.status === Constant.STATUS.ON_GOING ||
                  negotiation?.status === Constant.STATUS.DONE ||
                  (negotiation?.status === Constant.STATUS.CANCELED && negotiation?.startDate)) ? (
                  <Chat
                     permitSendMessage={permitMessage}
                     roomId={negotiationId}
                     username={accountName}
                     userId={accountId}
                     account={account}
                     negotiation={negotiation}
                  ></Chat>
               ) : (
                  <ChatReadOnly negotiation={negotiation} />
               )}
            </Col>
            <Col md="7">
               {accountName !== null && accountId !== null && (
                  <OfferNegotiation
                     account={account}
                     username={accountName}
                     negotiationId={negotiationId}
                     accountId={accountId}
                     fromAccountId={accountId}
                     toAccountId={toAccountId}
                     negotiation={negotiation}
                     setNegotiation={setNegotiation}
                  ></OfferNegotiation>
               )}
            </Col>
         </Row>
         <Row className="mt-4 mx-0 mb-5">
            <Col md="12" className="px-0">
               {accountName !== null && accountId !== null && (
                  <NegotiationOfferAsListModule
                     roomId={negotiationId}
                     negotiationId={negotiationId}
                     username={accountName}
                  ></NegotiationOfferAsListModule>
               )}
            </Col>
         </Row>
      </div>
   )
}

export default VendorNegotiationOnline
